package org.ksdfv.thelema.g3d

import org.ksdfv.thelema.anim.IAnim
import org.ksdfv.thelema.g3d.cam.ICamera
import org.ksdfv.thelema.g3d.light.ILight
import org.ksdfv.thelema.g3d.node.ITransformNode
import org.ksdfv.thelema.g3d.node.TransformNodeType

interface I3DGraphicsProvider {
    fun material(): IMaterial
    fun scene(): IScene
    fun armature(): IArmature
    fun object3d(): IObject3D
    fun node(nodeType: Int = TransformNodeType.TRS): ITransformNode
    fun light(lightType: Int): ILight
    fun camera(): ICamera
    fun anim(): IAnim
}